import { LegalContentPage } from "@/components/LegalContentPage";
import { WA_MESSAGES } from "@/lib/site";

export default function Documentos() {
  return (
    <LegalContentPage
      overline="Prepare-se"
      title="Documentos para viajar"
      subtitle="Reunimos orientações gerais para ajudar você a se organizar. Confirme sempre os detalhes com a equipe da Miríade antes da viagem."
      seoTitle="Documentos para Viajar | Miríade Turismo"
      seoDescription="Saiba quais documentos podem ser necessários para viagens nacionais e internacionais. Orientações gerais da Miríade Turismo."
      intro="A documentação necessária pode variar de acordo com o destino, a data da viagem, a companhia aérea e o perfil do viajante. Use as orientações abaixo como ponto de partida e conte com a Miríade para confirmar tudo antes de viajar."
      sections={[
        {
          heading: "Viagens nacionais",
          paragraphs: ["Para viagens dentro do Brasil, normalmente é necessário apresentar um documento oficial de identificação com foto e dentro da validade."],
          list: [
            "Documento oficial com foto (RG, CNH ou passaporte) dentro da validade.",
            "Atenção à validade do documento e à qualidade da foto.",
            "Para voos, confira as regras da companhia aérea sobre documentos aceitos.",
          ],
        },
        {
          heading: "Viagens internacionais",
          paragraphs: ["Viagens ao exterior podem exigir documentos adicionais, que variam conforme o país de destino."],
          list: [
            "Passaporte válido (atenção ao prazo mínimo de validade exigido por cada país).",
            "Visto, quando exigido pelo destino.",
            "Comprovantes de vacinas, quando solicitados.",
            "Seguro viagem, recomendado e obrigatório em alguns destinos.",
          ],
        },
        {
          heading: "Passaporte",
          paragraphs: ["O passaporte é o principal documento para viagens internacionais. Muitos países exigem validade mínima (geralmente seis meses) a partir da data de entrada. Verifique com antecedência e renove se necessário, pois o processo pode levar alguns dias."],
        },
        {
          heading: "Visto",
          paragraphs: ["Alguns destinos exigem visto, que deve ser providenciado antes da viagem. Os requisitos, prazos e formas de solicitação variam de país para país. Planeje-se com antecedência e confirme as exigências do seu destino com a nossa equipe."],
        },
        {
          heading: "Menores de idade",
          paragraphs: ["Viagens com crianças e adolescentes podem exigir documentos e autorizações específicas, especialmente quando o menor viaja desacompanhado ou sem um dos responsáveis."],
          list: [
            "Documento de identificação do menor.",
            "Autorização de viagem, quando exigida, conforme a situação.",
            "Para viagens internacionais, podem ser necessárias autorizações e documentos adicionais.",
          ],
        },
        {
          heading: "Vacinas e exigências sanitárias",
          paragraphs: ["Alguns destinos solicitam comprovação de vacinas ou outras exigências sanitárias. Essas regras podem mudar, por isso é importante verificar as informações atualizadas próximo à data da viagem."],
        },
      ]}
      note="As exigências de documentação podem variar conforme destino, data da viagem, companhia aérea e perfil do passageiro. Antes de finalizar sua viagem, confirme as informações com a equipe da Miríade Turismo."
      ctaTitle="Tem dúvidas sobre a documentação?"
      ctaText="Fale com a Miríade e confirme tudo o que você precisa antes de viajar."
      waMessage={WA_MESSAGES.documents}
    />
  );
}
